// O MENU DA VERSÃO CLÁSSICA — recuperado do histórico, e não redesenhado.
//
// Três pontos do T2, e o do meio é o que dá trabalho:
//
//   T2.1 "a versão clássica do HQ-Lab NÃO TEM CAMINHO DE VOLTA para a versão atual dela"
//   T2.2 "na versão clássica só tem a rota clássica, e a rota objetivo, passeio de biblioteca,
//         entrar, tudo continua na mesma ideia da aplicação normal. Então a ideia é que a gente
//         mantivesse para cada uma dessas rotas as ROTAS EQUIVALENTES DO JEITO QUE TAVA ANTES."
//   T2.3 "fazer esse resgate lá dos commits (...) GitHub, voltar"
//
// ── O RESGATE, E ELE É LITERAL: EU FUI AO HISTÓRICO ─────────────────────────────────────────
//
// `T2.3` manda recuperar do repositório em vez de refazer. Feito em 2026-09-12, no commit
// `55808e5` — o último antes do trabalho do T1, e o mesmo de onde a `landing-page.scss` já tinha
// sido restaurada byte a byte.
//
// O menu de lá, na íntegra:
//
//   QUEM SOMOS    -> /#quem-somos     (HashLink, ÂNCORA na própria página)
//   OBJETIVOS     -> /#objetivos      (âncora)
//   PARCEIROS     -> /#parceiros      (âncora)
//   deslogado:  LOGIN -> /login  ·  CADASTRO -> /cadastro
//   logado:     MINHA CONTA -> /minha-conta  ·  CONFIGURACOES -> /configuracoes
//               ·  MEUS QUADRINHOS (interceptado)
//
// E as rotas que existiam no `App.tsx` daquele commit eram SETE, e só sete:
//   /  /login  /cadastro  /minha-conta  /auth/action  /dashboard  /configuracoes
//
// ── O QUE ISSO RESPONDE, E É UM FATO E NÃO UMA OPINIÃO ─────────────────────────────────────
//
// `T2.2` nomeia quatro destinos. Depois do resgate:
//
//   objetivo    era ÂNCORA (`/#objetivos`) na própria landing, não rota. Aqui volta a ser âncora.
//   entrar      era `/login`, e continua sendo a MESMA tela — o login nunca foi redesenhado em
//               duas versões, então não há "equivalente clássico" a recriar.
//   biblioteca  **NÃO EXISTIA.** Nenhuma rota, nenhuma tela, nenhum componente. A biblioteca
//               nasceu no T1 — é a "vitrine nova que eu coloquei" de que o próprio time fala em
//               `[A3-P11]`.
//   passeio     **NÃO EXISTIA.** Não há `passeio` em rota, em âncora nem em seção da landing de
//               `55808e5`. (O assunto "Passeios" aparece na reunião como a dúvida D5, sobre
//               escopo de MVP, e o operador a adiou.)
//
// Então "as rotas equivalentes do jeito que tava antes" tem resposta para DUAS das quatro, e para
// as outras duas a resposta é que não havia o que equivaler. Por isso este menu não oferece
// biblioteca: oferecê-la levaria de novo para a tela moderna, que é exatamente a queixa do T2.2.
//
// ── A DÚVIDA D7, E POR QUE ELA NÃO IMPEDIU ISTO ────────────────────────────────────────────
//
// `T2.3` traz um trecho que ninguém decifrou: *"dos comentários que eu não fiz"*. O operador deu
// autonomia em 2026-09-12, e a decisão está em `DECISOES-COM-AUTONOMIA.md`: **executar o que é
// claro.** O resto da frase é inequívoco — recuperar do histórico —, e o trecho ambíguo só
// mudaria *o que mais* buscar (mensagem de commit, comentário de PR, anotação de revisão), não
// *se* buscar.
//
// O que eu busquei está listado acima, com o commit. Se a resposta dele vier, é acréscimo e não
// recomeço.

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../global-state-context";
import Firebase from "../../api/firebase.class";

/**
 * ÂNCORA NA PRÓPRIA PÁGINA, e não `<Link to="/#x">`.
 *
 * O menu antigo usava `react-router-hash-link`, que não está mais nas dependências. Um `<a href>`
 * com `#` faz o que ele fazia — o navegador rola até o id — e sem biblioteca a mais. E aqui a
 * âncora é ainda mais simples que lá: a versão clássica É a página que tem as seções, então o
 * destino é sempre a própria tela.
 */
function Ancora({ para, children }: { para: string; children: React.ReactNode }) {
  return (
    <a className="nav-link" href={`#${para}`}>
      {children}
    </a>
  );
}

function NavClassico() {
  const navigate = useNavigate();
  const globalState = useGlobalState();
  const isLogged = !!globalState?.appUser;
  const [aberto, setAberto] = useState(false);

  // T8.15 · o mesmo aviso do menu novo. A versao classica preserva os DEFEITOS DE LAYOUT dela por
  // decisao (ver o classico.tsx), e nao os dialogos do navegador: um `alert()` nao e layout, e a
  // sessao que nao fecha num computador de escola nao e nostalgia.
  const [erroAoSair, setErroAoSair] = useState<string | null>(null);

  useEffect(() => setAberto(false), [isLogged]);

  return (
    <nav className="nav-container" aria-label="Navegação da versão clássica">
      {/* ── O CAMINHO DE VOLTA — T2.1 ─────────────────────────────────────────────────────
          "a versão clássica do HQ-Lab não tem caminho de volta para a versão atual dela."

          A volta EXISTIA, medido em 12/09: o logo do `nav.tsx` aponta para `/`. O que não existia
          era o RÓTULO. A entrada, por contraste, é um link com texto no rodapé — "Ver a versão
          clássica". Assimetria de nome, não de rota: a porta de entrada dizia o que era, a de
          saída não.

          Agora as duas dizem. E fica no canto da marca, que é onde a pessoa procura "início". */}
      {/* T9.21 · O `aria-label` existe porque o NOME ACESSÍVEL do link era a emenda dos dois
          textos, sem separador: "HQ-LABvoltar para a versão atual". Isso é o que o leitor de
          tela anuncia, e nenhuma margem conserta — o espaço é visual, o nome é texto. */}
      <Link
        className="nav-marca"
        to="/"
        aria-label="HQ-Lab — voltar para a versão atual"
      >
        HQ-LAB
        <span className="nav-voltar-moderna">voltar para a versão atual</span>
      </Link>

      <button
        type="button"
        className="menu-toggle"
        aria-expanded={aberto}
        aria-controls="nav-classico-links"
        onClick={() => setAberto((x) => !x)}
      >
        <span className="visualmente-oculto">{aberto ? "Fechar menu" : "Abrir menu"}</span>
        <span aria-hidden="true">☰</span>
      </button>

      <div id="nav-classico-links" className={`nav-links ${aberto ? "open" : ""}`}>
        {/* As três âncoras, como eram. */}
        <Ancora para="quem-somos">Quem somos</Ancora>
        <Ancora para="objetivos">Objetivos</Ancora>
        <Ancora para="parceiros">Parceiros</Ancora>

        {!isLogged && (
          <>
            <Link className="nav-link" to="/login">
              Entrar
            </Link>
            <Link className="nav-link" to="/cadastro">
              Criar conta
            </Link>
          </>
        )}

        {isLogged && (
          <>
            <Link className="nav-link" to="/meus-quadrinhos">
              Meus quadrinhos
            </Link>
            <Link className="nav-link" to="/minha-conta">
              Minha conta
            </Link>
            <button
              type="button"
              className="nav-sair"
              onClick={async () => {
                // Sai primeiro, navega depois — a lição do T1.35, e ela vale nas duas versões.
                try {
                  await Firebase.logOut();
                } catch (err) {
                  console.error("[nav-classico] falha ao sair da conta", err);
                  // T8.15 · o mesmo aviso do menu novo, na versao classica. O estado e declarado
                  // abaixo, junto dos outros desta barra.
                  setErroAoSair("Não deu para sair da sua conta agora. Tente de novo em instantes.");
                  return;
                }
                navigate("/");
              }}
            >
              Sair
            </button>
          </>
        )}

        {erroAoSair && (
          <p className="nav-erro-ao-sair" role="alert">
            {erroAoSair}
          </p>
        )}
      </div>
    </nav>
  );
}

export default NavClassico;
